import React from "react";
import { MainHeader } from "../components/global/MainHeader";
import { Socials } from "../components/Home/Socials";
import { BookingBody } from "../components/bookings/BookingBody";

export const Bookings = () => {
  return (
    <React.Fragment>
      <MainHeader name={"Book An Appointment"} />
      <BookingBody />
      <Socials imgSrc={"SBD/StrandsHairs.png"} />
    </React.Fragment>
  );
};
